import { render, staticRenderFns } from "./inspectorChargeStatistics.vue?vue&type=template&id=5370bf50&scoped=true&"
import script from "./inspectorChargeStatistics.vue?vue&type=script&lang=js&"
export * from "./inspectorChargeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./inspectorChargeStatistics.vue?vue&type=style&index=0&id=5370bf50&scoped=true&lang=css&"
import style1 from "./inspectorChargeStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370bf50",
  null
  
)

export default component.exports